import { render, staticRenderFns } from "./StoryControlBlock.vue?vue&type=template&id=d805de58&scoped=true&"
import script from "./StoryControlBlock.vue?vue&type=script&lang=js&"
export * from "./StoryControlBlock.vue?vue&type=script&lang=js&"
import style0 from "./StoryControlBlock.vue?vue&type=style&index=0&id=d805de58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d805de58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
